import { Settings } from '@ecm/config/Settings'
import { Author } from '@ecm/data/Author'
import { runEff } from '@ecm/effect'
import AuthorArticlesList, {
  AuthorArticlesListProps,
} from '@ecm/ui/component/blog/AuthorArticlesList'
import { BreadCrumb } from '@ecm/ui/element/Breadcrumbs'

export const AuthorPage = ({
  author,
  articles,
  authorId,
  breadCrumb,
  currentPage,
  totalPages,
}: AuthorArticlesListProps) => (
  <AuthorArticlesList
    author={author}
    articles={articles}
    authorId={authorId}
    breadCrumb={breadCrumb}
    currentPage={currentPage}
    totalPages={totalPages}
  />
)

export default AuthorPage

export const getStaticProps = async (ctx: { params: { id: string; page: string } }) => {
  const page = ctx.params?.page

  const defaultAuthor = {
    fullname: 'Earth Class Mail Team',
  }

  if (!page && Array.isArray(page)) {
    return
  }

  const pageNumber = Number(page)

  const authorId = ctx.params?.id

  const articlesByAuthor = await runEff(async eff => {
    if (!authorId) {
      return null
    }
    try {
      return await eff.getPaginatedArticlesById(authorId, pageNumber)
    } catch (e) {
      return null
    }
  })
  if (!articlesByAuthor) {
    return {
      props: {
        articles: [],
        author: defaultAuthor,
        totalPages: 0,
      },
    }
  }

  const breadCrumb: BreadCrumb[] = [
    { description: 'Blog', href: '/blog', position: 2 },
    {
      description: articlesByAuthor.items.length
        ? articlesByAuthor.items[0].author.fullname
        : 'EarthClassMail',
      href: `/blog/${authorId}`,
      position: 3,
    },
  ]
  const totalPages = Math.ceil(articlesByAuthor.total / Settings.pagination.pageSize)

  return {
    props: {
      articles: articlesByAuthor.items,
      author: articlesByAuthor.items.length ? articlesByAuthor.items[0].author : defaultAuthor,
      authorId,
      breadCrumb,
      currentPage: pageNumber,
      totalPages: totalPages,
    },
  }
}

export async function getStaticPaths() {
  const authors: Author[] = await runEff(eff => eff.getAuthors())
  const metadataPromises = authors.map(async a => {
    const meta = await runEff(eff => eff.getArticlesMetadataById(a.id))
    return {
      id: a.id,
      total: meta.total,
    }
  })

  const metadata = await Promise.all(metadataPromises)

  const paths = metadata
    .map(data => {
      const item = []
      const totalPages = Math.ceil(data.total / Settings.pagination.pageSize)
      for (let i = 1; i <= totalPages; i++) {
        item.push({ params: { id: data.id.toString(), page: i.toString() } })
      }
      return item
    })
    .flat()

  return {
    fallback: false,
    paths,
  }
}
